﻿import React, { forwardRef, useState } from "react";
import { Input, InputProps } from "@chakra-ui/react";

type DatePickerProps = InputProps;
export const DatePicker: React.FC<DatePickerProps> = forwardRef(({ placeholder, onFocus, onBlur, onChange, ...props }, ref) => {
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState<string | undefined>(undefined);
    return (
        <Input
            ref={r => {
                // @ts-ignore
                ref?.(r);
                if (r?.value && r.value.length > 0) {
                    setValue(r.value);
                }
            }}
            color={focused || (value && value.length > 0) ? "" : "var(--chakra-colors-chakra-placeholder-color)"}
            type={"date"}
            placeholder={placeholder || "mm/dd/yyyy"}
            onFocus={e => {
                setFocused(true);
                if (onFocus) {
                    onFocus(e);
                }
            }}
            onBlur={e => {
                setFocused(false);
                if (onBlur) {
                    onBlur(e);
                }
            }}
            onChange={e => {
                setValue(e.target.value);
                if (onChange) {
                    onChange(e);
                }
            }}
            {...props}
        />
    );
});
